import { Component, computed, inject, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoUnsubscribe } from 'weavix-shared/utils/utils';
import { environment } from 'environments/environment';
import { isEqual } from 'lodash';
import { ChannelService, PendingAttachment } from 'weavix-shared/services/channel.service';
import { CarouselAttachment, MessageAttachment, MessageAttachmentType } from '@weavix/models/src/channel/channel-message';
import { ImagePreviewComponent } from 'components/image-preview/image-preview.component';
import { TranslateModule } from '@ngx-translate/core';

@AutoUnsubscribe()
@Component({
    selector: 'app-media-carousel',
    templateUrl: './media-carousel.component.html',
    styleUrls: ['./media-carousel.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,

        ImagePreviewComponent,
    ],
})
export class MediaCarouselComponent {
    private readonly channelService = inject(ChannelService);

    readonly selectedAttachment = model<MessageAttachment | PendingAttachment>();
    readonly attachmentList = input<CarouselAttachment[]>([]);
    readonly embeddedView = input(false);
    readonly thumbnail = input(false);

    readonly attachmentClick = output<MessageAttachment>();

    readonly teamsApp = environment.teamsApp;
    readonly buttonHovers: { [id: string]: boolean } = {};

    readonly videoBlobUrl = computed(() => {
        const selectedAttachment = this.selectedAttachment();
        if (selectedAttachment?.type === MessageAttachmentType.Video && !selectedAttachment.file?.uri) {
            const videoBlob = new Blob([(selectedAttachment as PendingAttachment)?.raw], { type: 'video/mp4' });
            return URL.createObjectURL(videoBlob);
        }
        return undefined;
    });

    async onCarouselClickLeft(event: MouseEvent) {
        event.stopPropagation();
        const index = this.selectedCarouselAttachmentIndex();
        if (index <= 0) return;
        this.selectedAttachment.set(this.attachmentList()[index - 1].attachment);
    }

    async onCarouselClickRight(event: MouseEvent) {
        event.stopPropagation();
        const index = this.selectedCarouselAttachmentIndex();
        if (index >= this.attachmentList().length - 1) return;
        this.selectedAttachment.set(this.attachmentList()[index + 1].attachment);
    }

    async downloadAttachment(attachment: MessageAttachment | PendingAttachment) {
        await this.channelService.downloadAttachment(attachment.file.uri);
    }

    readonly selectedCarouselAttachmentIndex = computed(() => {
        const selectedAttachment = this.selectedAttachment();
        return this.attachmentList().findIndex(attach => isEqual(attach.attachment, selectedAttachment));
    });
}
